import { PageContentWrapper } from '@lmc/ui-kit'
import useHomeType from 'hooks/useHomeType'
import { RotaPatternView } from '../RotaPattern/RotaPatternView'

export const RotaViewShiftsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContentWrapper $paddingTop={24} $paddingX={48} $paddingBottom={24}>
      <RotaPatternView type="shift" />
    </PageContentWrapper>
  )
}
